import { useAccountsQuery } from './useAccountsQuery';
import { useAccountsSearch } from './useAccountsSearch';
import { columns } from '../tables/columns';

export const useAccounts = (filters: Record<string, string> = {}) => {
    const { data: items = [], isLoading: loading } = useAccountsQuery(filters);
    const { keyword } = useAccountsSearch();

    // Filter items based on keyword (client-side filtering)
    const visibleItems = items.filter(item =>
        !keyword ||
        item.email?.toLowerCase().includes(keyword.toLowerCase()) ||
        item.username?.toLowerCase().includes(keyword.toLowerCase())
    );

    return {
        items,
        visibleItems,
        loading,
        columns,
    };
};
